import React, { Component } from 'react';
import Container from '../container';

require('./NotFoundScreen.scss');

class NotFound extends Component {
    render() {
	return (
	    <Container>
		<section className="notFoundScreen container-fluid">
		    <div className="row input-header">
			<div className="col-xs-12 inputTitle">
			    <h1>404.. This page is not found!</h1>
			</div>
		    </div>
		</section>
	    </Container>
	);
    }
}

export default NotFound;



// WEBPACK FOOTER //
// ./app/components/404/NotFound.jsx